import styled from 'styled-components';
import copy from 'copy-to-clipboard';
import _ from 'lodash';
import ErrorIcon from '@material-ui/icons/Error';
import Tooltip from '@material-ui/core/Tooltip';
import { ALERT_TYPES } from 'common/constants/alertTypes';
import { SPACES } from 'common/constants/sizes';
import { getColor } from 'common/constants/_colors';
import { TRACKING } from 'common/constants/constants';
import * as TrackingService from 'common/services/tracking.service';
import { resetTooltipPadding } from 'components/Tooltips/helpers';
import { Flex } from 'components/base/layout-components';
import Text from 'components/base/Text';
import Icon from 'components/base/Icon';
import { getIssueAlertText } from '../../dashboard/components/StuckIssues/stuck-issues.service';
import { LBButton } from '@linearb/buzz';

const TooltipContentWrapper = styled.div`
  width: 30rem;
`;

const TooltipTitle = styled(Text)`
  padding: 1rem 1.5rem;
`;

const TooltipFooter = styled(Text)`
  padding: 1rem 1.5rem;
  border-top: 2px solid ${getColor('catskillWhite')};
`;

const TooltipBox = styled(Flex)`
  padding: 1.5rem;
  border-top: 2px solid ${getColor('catskillWhite')};
`;

const AlertColumn = styled(Flex)`
  padding: 0 1.2rem;
  align-items: center;
  height: 4.8rem;
  background-color: ${getColor('serenade')};
`;

const alertsLimit = 3;

const StuckCol = ({ alerts }) => {
  // Make sure issues are unique
  alerts = _.uniqBy(alerts, 'id');
  return alerts.length ? (
    <Tooltip
      onOpen={_.once(() => {
        TrackingService.logEvent(TRACKING.EVENTS.HOVER, {
          page: TRACKING.PAGES.PULSE,
          element_name: TRACKING.ELEMENT_NAME.DELIVERY_ALERT
        });
      })}
      classes={resetTooltipPadding()}
      interactive
      placement='top-end'
      title={
        <TooltipContentWrapper>
          <TooltipTitle weight='700' size='large'>
            Stuck Issues
          </TooltipTitle>
          {alerts.slice(0, alertsLimit).map(alert => {
            const title = getIssueAlertText(alert);
            const prLink = alert.pr_html;
            const linkPathname = new URL(prLink).pathname;
            return (
              <TooltipBox direction='row' key={alert.id}>
                <Flex items='start' pr='small'>
                  <Text color='orangePeel'>
                    <ErrorIcon size='large' color='inherit' />
                  </Text>
                </Flex>
                <Flex items='start' direction='column'>
                  <Text size='large' pb={SPACES['x-small']}>
                    {title}
                  </Text>
                  <Flex pb='x-small'>
                    <span className='text-xs rounded-sm bg-slate-200 flex flex-col items-center'>
                      <a
                        onClick={() => {
                          TrackingService.logEvent(TRACKING.EVENTS.CLICK, {
                            page: TRACKING.PAGES.PULSE,
                            click_type: TRACKING.CLICK.ALERT_PR_GIT_LINK
                          });
                        }}
                        href={prLink}
                        target='_blank'
                      >
                        {linkPathname}
                      </a>
                    </span>
                    <LBButton
                      variant='link'
                      size='icon'
                      onClick={() => copy(prLink)}
                    >
                      <Icon name='Clipboard' />
                    </LBButton>
                  </Flex>
                  <Text size='medium' color='shuttleGray'>
                    PR Owner: {alert.pr_issuer_name}
                  </Text>
                </Flex>
              </TooltipBox>
            );
          })}
          {alerts.length > alertsLimit && (
            <TooltipFooter size='medium'>
              + {alerts.length - alertsLimit} more
            </TooltipFooter>
          )}
        </TooltipContentWrapper>
      }
    >
      <AlertColumn>
        <Text color='orangePeel' pr={SPACES['x-small']}>
          <ErrorIcon size='large' color='inherit' />
        </Text>
        <Text weight='500' size='medium' align='center'>
          {alerts.length === 1
            ? ALERT_TYPES[alerts[0].type].alert_title
            : `${alerts.length} Alerts`}
        </Text>
      </AlertColumn>
    </Tooltip>
  ) : null;
};

export default StuckCol;
